import {Injectable} from "@angular/core";
import {ReportsUtil} from "../../../../util/Reports";
import * as moment from "moment";

@Injectable({
  providedIn: 'root'
})

/*
01/09/2025 - Kauan
classe para chamar o reportsUtil, são vários métodos diferentes, já que o tamanho dos gráficos, e o melhor posicionamento de cada
um varia. O titulo altera o cabeçalho, período os anos a direita e headerImage um boolean para usar ou nao a imagem do escritório
na hora de exportar
*/

export class ExportPdfWithChartImages {
  constructor(private reportsUtil: ReportsUtil) {

  }
  exportTwoBars(titulo: string, arquivo: string, period : string, headerImage: boolean){

    const date = moment().format('DD/MM/YY HH:mm').toString();

    this.reportsUtil.exportPDF({
      doc: {
        arquivo: arquivo,
        orientacao: 'Landscape',
      },
      cabecalho: {
        image: headerImage,
        titulo: titulo,
        data: date,
        periodo: period,
        parametros: {
        },
      },
      tabela: {
        dados: null,
        colunas: null,
        estiloColunas: null,
        chartImages: 'two_img_double_bar',
        cabecalhoEscondido: false
      },
    });
  }

  exportTwoPies(titulo: string, arquivo: string, period : string, headerImage: boolean){
    const date = moment().format('DD/MM/YY HH:mm').toString();

    this.reportsUtil.exportPDF({
      doc: {
        arquivo: arquivo,
        orientacao: 'Landscape',
      },
      cabecalho: {
        image: headerImage,
        titulo: titulo,
        data: date,
        periodo: period,
        parametros: {
        },
      },
      tabela: {
        dados: null,
        colunas: null,
        estiloColunas: null,
        chartImages: 'two_img_double_pie',
        cabecalhoEscondido: false
      },
    });
  }

  exportBarAndPie(titulo: string, arquivo: string, period : string, headerImage: boolean){
    const date = moment().format('DD/MM/YY HH:mm').toString();

    this.reportsUtil.exportPDF({
      doc: {
        arquivo: arquivo,
        orientacao: 'Landscape',
      },
      cabecalho: {
        image: headerImage,
        titulo: titulo,
        data: date,
        periodo: period,
        parametros: {
        },
      },
      tabela: {
        dados: null,
        colunas: null,
        estiloColunas: null,
        chartImages: 'two_img_double_pie_bar',
        cabecalhoEscondido: false
      },
    });
  }

  exportGerencial(titulo: string, arquivo: string, period : string, headerImage: boolean){
    const date = moment().format('DD/MM/YY HH:mm').toString();
  //params.cabecalho.image
    this.reportsUtil.exportPDF({
      doc: {
        arquivo: arquivo,
        orientacao: 'Landscape',
      },
      cabecalho: {
        image: headerImage,
        titulo: titulo,
        data: date,
        periodo: period,
        parametros: {
        },
      },
      tabela: {
        dados: null,
        colunas: null,
        estiloColunas: null,
        chartImages: 'gerencial',
        cabecalhoEscondido: false
      },
    });
  }

  exportSingle(titulo: string, arquivo: string, period : string, headerImage: boolean){
    const date = moment().format('DD/MM/YY HH:mm').toString();

    this.reportsUtil.exportPDF({
      doc: {
        arquivo: arquivo,
        orientacao: 'Landscape',
      },
      cabecalho: {
        image: headerImage,
        titulo: titulo,
        data: date,
        periodo: period,
        parametros: {
        },
      },
      tabela: {
        dados: null,
        colunas: null,
        estiloColunas: null,
        chartImages: 'one_img'
      },
    });
  }
}
